export enum TECHNICAL_INFO_TEST_IDS {
    APP_VESRION_TEXT = 'app_version_text',
}
